import { render } from "./AddNotificationCampagnePage.vue?vue&type=template&id=427c4d74&ts=true"
import script from "./AddNotificationCampagnePage.vue?vue&type=script&lang=ts"
export * from "./AddNotificationCampagnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__